import {GameDataFirstGameState} from '@colonist/game-state-types'
import {GameStateEnums, NetworkEnums} from '../../../shared/GameEnums'
import {SocketDataTypes} from '../../../shared/SocketDataTypes'
import {SocketActionController} from '../../shared/scripts/socket/SocketActionController'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'
import {UIGameManager} from '../../shared/scripts/ui_game/UIGameManager'
import {UIManager} from './ui_html/UIManager'
import {Scene} from './ui_html/UISceneTypes'
import {UIUrlController} from '../../shared/scripts/ui_html/UIUrlController'
import {UIPopupFunnelIncentiveController} from './ui_popup/UIPopupFunnelIncentiveController'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MatchmakingStatusUpdate} from '../../../shared/matchmaking/MatchmakingInterfaces'
import {UIAdBlockController} from './ui_ad/UIAdBlockController'
import {UIRoomController} from './ui_html/room/UIRoomController'
import {BaseError} from '../../../shared/errors/BaseError'
import {ChatData} from '@colonist/shared-types'
import {UIWGeneralServicesController} from './UIWGeneralServicesController'
import {setGlobalGameEndNumberOfPlayersJoinedRematch} from '@colonist/ui-game'
import {showMatchmakingErrorPopup} from '../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts'

export class SocketWebActionController extends SocketActionController {
    readonly uiGameManager: UIGameManager | undefined
    protected readonly uiManager: UIManager | undefined
    private hasDisplayedLoginIncentive: boolean = false

    constructor(uiGameManager: UIGameManager | undefined, uiManager: UIManager | undefined, generalServicesController: UIWGeneralServicesController) {
        super(generalServicesController)
        this.uiGameManager = uiGameManager
        this.uiManager = uiManager
    }

    // eslint-disable-next-line class-methods-use-this
    onChatText(chatData: ChatData) {
        return
    }

    onStateSessionState() {
        const isAdblockActive = this.uiManager?.adController.adblockState.isAdblockActive ?? false
        SocketLobbySend.setAdBlockStatusToUserSession(isAdblockActive)

        const accessGameFromLink = UIUrlController.getRoomIdFromUrl() !== undefined

        if(!this.hasDisplayedLoginIncentive) UIPopupFunnelIncentiveController.showPopup(accessGameFromLink)
        this.hasDisplayedLoginIncentive = true
    }

    onConnectionEstablished(data: GameDataFirstGameState) {
        this.uiManager?.sceneController.loadScene(Scene.Game)
        UIRoomController.updateURLToRoom(data.gameSettingId)
    }

    onStateInitialPlacement() {
        this.uiManager?.sceneController.loadScene(Scene.Game)
    }

    onMatchmakingUpdate(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.uiManager?.matchmakingController.updateMatchmakingStatus(matchmakingStatusUpdate)
    }

    onMatchmakingError(error: BaseError) {
        this.uiManager?.matchmakingController.removePopups()
        showMatchmakingErrorPopup(error)
    }

    // eslint-disable-next-line class-methods-use-this
    onMatchmakingDisableAdblock() {
        const noContinueAction = () => undefined
        UIAdBlockController.showDisableAdblockPopup(noContinueAction, false, false)
    }

    // eslint-disable-next-line class-methods-use-this
    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        return
    }

    onRoomListUpdate(data: NetworkEnums.RoomListUpdateData) {
        this.uiManager?.lobby.updateRoomList(data)
    }

    // eslint-disable-next-line class-methods-use-this
    onEndGameText(data: any) {
        const playersJoinedRematch: number = data
        setGlobalGameEndNumberOfPlayersJoinedRematch(playersJoinedRematch)
    }
}
